import Approval from "@mui/icons-material/ApprovalOutlined";
import ArticleIcon from "@mui/icons-material/Article";
import BusinessIcon from "@mui/icons-material/Business";
import SettingsIcon from "@mui/icons-material/Settings";
import { VpnKey, People, Folder, History } from "@mui/icons-material";

const conf = {
  IDPS: [
    { label: "LOCAL", value: "LOCAL", disabled: false },
    { label: "MICROSOFT", value: "MICROSOFT", disabled: false },
    { label: "AUTH0", value: "AUTH0", disabled: true },
    { label: "PING", value: "PING", disabled: true },
    { label: "OKTA", value: "OKTA", disabled: true }
  ],
  ROLES: [
    "org.admin",
    "org.auditor",
    "org.key.custodian",
    "org.project.manager"
    // "sys.admin", // note: removed from list due to global access/rights
  ],
  TILES: {
    ["sys.admin"]: [
      { icon: <People />, key: "users", path: "/users" },
      { icon: <History />, key: "audit", path: "/audit" },
      { icon: <BusinessIcon />, key: "orgs", path: "/organizations" },
      { icon: <SettingsIcon />, key: "settings", path: "/organization" }
    ],
    ["org.admin"]: [
      { icon: <People />, key: "users", path: "/users" },
      { icon: <History />, key: "audit", path: "/audit" },
      { icon: <BusinessIcon />, key: "org", path: "/organization" }
    ],
    ["org.auditor"]: [
      { icon: <People />, key: "users", path: "/users" },
      { icon: <History />, key: "audit", path: "/audit" }
    ],
    ["org.key.custodian"]: [
      { icon: <VpnKey />, key: "keys", path: "/keys" },
      { icon: <Folder />, key: "projects", path: "/projects" },
      { icon: <Approval />, key: "requests", path: "/requests/pending" },
      { icon: <People />, key: "users", path: "/users" },
      { icon: <History />, key: "audit", path: "/audit" },
      { icon: <ArticleIcon />, key: "docs", path: "/docs", disabled: true }
    ],
    ["org.project.manager"]: [
      { icon: <VpnKey />, key: "keys", path: "/keys" },
      { icon: <Folder />, key: "projects", path: "/projects" },
      { icon: <Approval />, key: "requests", path: "/requests/pending" },
      { icon: <People />, key: "users", path: "/users" },
      { icon: <History />, key: "audit", path: "/audit" },
      { icon: <ArticleIcon />, key: "docs", path: "/docs", disabled: true }
    ]
  },
  EVENTS: {
    ["org.admin"]: [
      "SIGNIN",
      "SIGNOUT",
      "ORG_INVITE",
      "ORG_INVITE_EXPIRED",
      "ORG_INVITE_CANCELED",
      "ORG_INVITE_ACCEPTED",
      "ORG_ACCOUNT_REMOVED",
      "ORG_IDP_ADD",
      "ORG_IDP_EDIT",
      "ORG_IDP_REMOVE"
    ],
    ["org.auditor"]: [
      "ORG_PROJECT_RESET",
      "ORG_PROJECT_CREATE",
      "ORG_PROJECT_REMOVE",
      "ORG_PROJECT_EDIT_TAGS",
      "ORG_PROJECT_EDIT_DESCRIPTION",
      "ORG_PROJECT_ACTIVATE",
      "ORG_PROJECT_DEACTIVATE",
      "ORG_PROJECT_KEY_UPLOAD",
      "ORG_PROJECT_KEY_REMOVE",
      "ORG_PROJECT_KEY_DOWNLOAD",
      "ORG_PROJECT_KEY_CREATE_REQUEST",
      "ORG_PROJECT_KEY_CREATE_APPROVE",
      "ORG_PROJECT_KEY_CREATE_REJECT",
      "ORG_PROJECT_KEY_IMPORT_REQUEST",
      "ORG_PROJECT_KEY_IMPORT_APPROVE",
      "ORG_PROJECT_KEY_IMPORT_REJECT",
      "ORG_PROJECT_KEY_PUSH",
      "ORG_PROJECT_KEY_PUSH_CANCEL",
      "ORG_PROJECT_KEY_PUSH_SCHEDULE",
      "ORG_PROJECT_KEY_EDIT_TAGS",
      "ORG_PROJECT_KEY_EDIT_PART_NUMBER",
      "ORG_PROJECT_KEY_EDIT_DESCRIPTION"
    ],
    ["org.key.custodian"]: [
      "ORG_PROJECT_RESET",
      "ORG_PROJECT_CREATE",
      "ORG_PROJECT_REMOVE",
      "ORG_PROJECT_EDIT_TAGS",
      "ORG_PROJECT_EDIT_DESCRIPTION",
      "ORG_PROJECT_ACTIVATE",
      "ORG_PROJECT_DEACTIVATE",
      "ORG_PROJECT_KEY_UPLOAD",
      "ORG_PROJECT_KEY_REMOVE",
      "ORG_PROJECT_KEY_DOWNLOAD",
      "ORG_PROJECT_KEY_CREATE_REQUEST",
      "ORG_PROJECT_KEY_CREATE_APPROVE",
      "ORG_PROJECT_KEY_CREATE_REJECT",
      "ORG_PROJECT_KEY_IMPORT_REQUEST",
      "ORG_PROJECT_KEY_IMPORT_APPROVE",
      "ORG_PROJECT_KEY_IMPORT_REJECT",
      "ORG_PROJECT_KEY_PUSH",
      "ORG_PROJECT_KEY_PUSH_CANCEL",
      "ORG_PROJECT_KEY_PUSH_SCHEDULE",
      "ORG_PROJECT_KEY_EDIT_TAGS",
      "ORG_PROJECT_KEY_EDIT_PART_NUMBER",
      "ORG_PROJECT_KEY_EDIT_DESCRIPTION"
    ],
    ["org.project.manager"]: [
      "ORG_PROJECT_RESET",
      "ORG_PROJECT_CREATE",
      "ORG_PROJECT_REMOVE",
      "ORG_PROJECT_EDIT_TAGS",
      "ORG_PROJECT_EDIT_DESCRIPTION",
      "ORG_PROJECT_ACTIVATE",
      "ORG_PROJECT_DEACTIVATE",
      "ORG_PROJECT_KEY_UPLOAD",
      "ORG_PROJECT_KEY_REMOVE",
      "ORG_PROJECT_KEY_DOWNLOAD",
      "ORG_PROJECT_KEY_CREATE_REQUEST",
      "ORG_PROJECT_KEY_CREATE_APPROVE",
      "ORG_PROJECT_KEY_CREATE_REJECT",
      "ORG_PROJECT_KEY_IMPORT_REQUEST",
      "ORG_PROJECT_KEY_IMPORT_APPROVE",
      "ORG_PROJECT_KEY_IMPORT_REJECT",
      "ORG_PROJECT_KEY_PUSH",
      "ORG_PROJECT_KEY_PUSH_CANCEL",
      "ORG_PROJECT_KEY_PUSH_SCHEDULE",
      "ORG_PROJECT_KEY_EDIT_TAGS",
      "ORG_PROJECT_KEY_EDIT_PART_NUMBER",
      "ORG_PROJECT_KEY_EDIT_DESCRIPTION"
    ],
    ["sys.admin"]: [
      "SIGNUP",
      "SIGNIN",
      "SIGNOUT",
      "SESSION_TIMEOUT",
      "ORG_INVITE",
      "ORG_INVITE_EXPIRED",
      "ORG_INVITE_CANCELED",
      "ORG_INVITE_ACCEPTED",
      "ORG_ACCOUNT_REMOVED",
      "ORG_IDP_ADD",
      "ORG_IDP_EDIT",
      "ORG_IDP_REMOVE",
      "ORG_CONNECT",
      "ORG_PROJECT_RESET",
      "ORG_PROJECT_CREATE",
      "ORG_PROJECT_REMOVE",
      "ORG_PROJECT_EDIT_TAGS",
      "ORG_PROJECT_EDIT_DESCRIPTION",
      "ORG_PROJECT_ACTIVATE",
      "ORG_PROJECT_DEACTIVATE",
      "ORG_PROJECT_KEY_UPLOAD",
      "ORG_PROJECT_KEY_REMOVE",
      "ORG_PROJECT_KEY_DOWNLOAD",
      "ORG_PROJECT_KEY_CREATE_REQUEST",
      "ORG_PROJECT_KEY_CREATE_APPROVE",
      "ORG_PROJECT_KEY_CREATE_REJECT",
      "ORG_PROJECT_KEY_IMPORT_REQUEST",
      "ORG_PROJECT_KEY_IMPORT_REJECT",
      "ORG_PROJECT_KEY_IMPORT_APPROVE",
      "ORG_PROJECT_KEY_PUSH",
      "ORG_PROJECT_KEY_PUSH_CANCEL",
      "ORG_PROJECT_KEY_PUSH_SCHEDULE",
      "ORG_PROJECT_KEY_EDIT_TAGS",
      "ORG_PROJECT_KEY_EDIT_PART_NUMBER",
      "ORG_PROJECT_KEY_EDIT_DESCRIPTION"
    ]
  },
  COLUMNS: {
    SYS: {
      ORGS: [
        { key: "name", label: "Name", isHeader: true },
        {
          key: "online",
          label: "Status",
          description: "Denotes organization status"
        },
        { key: "domain", label: "Domain" },
        { key: "activeUsers", label: "Users" },
        { key: "description", label: "Description" },
        { key: "lastActive", label: "Last active" }
      ]
    },
    IDP: [
      { key: "name", label: "Name", isHeader: true, description: "" },
      { key: "authority", label: "Authority", description: "" },
      { key: "tenantId", label: "Tenant ID", description: "" },
      { key: "clientId", label: "Client ID", description: "" },
      { key: "clientSecret", label: "Secret", description: "" }
    ],
    KEYS: [
      { key: "name", label: "Name", isHeader: true },
      { key: "status", label: "Status" },
      { key: "algorithm", label: "Algorithm" },
      { key: "partNumber", label: "Part no." },
      { key: "project.name", label: "Project" },
      { key: "createdAt", label: "Created" },
      { key: "tags", label: "Tags" }
    ],
    USERS: {
      MGMT: [
        { key: "email", label: "Email", isHeader: true },
        { key: "status", label: "Account", disabled: true, description: "Current account status" },
        { key: "role", label: "Role", disabled: true },
        { key: "lastActive", label: "Last active" },
        { key: "project.assigned", label: "Assigned", disabled: true }
      ],
      BASE: [
        { key: "email", label: "Email", isHeader: true },
        { key: "status", label: "Account", disabled: true, description: "Current account status" },
        { key: "role", label: "Role", disabled: true },
        { key: "firstName", label: "First name" },
        { key: "lastName", label: "Last name" },
        { key: "lastActive", label: "Last active" }
      ],
      SYS: [
        { key: "email", label: "Email", isHeader: true },
        { key: "status", label: "Account", description: "Current account status" },
        { key: "activeOrganization.name", label: "Active org" },
        { key: "activeOrganization.role", label: "Active role" },
        { key: "firstName", label: "First name" },
        { key: "lastName", label: "Last name" },
        { key: "lastActive", label: "Last active" }
      ]
    },
    TERMS: [
      { key: "version", label: "Version", isHeader: true },
      { key: "hash", label: "ID" },
      {
        key: "current",
        label: "Status",
        description: "Denotes organization terms status"
      },
      { key: "updatedAt", label: "Updated" }
    ],
    EVENTS: [
      { key: "email", label: "Email", isHeader: true },
      { key: "updatedAt", label: "Date" },
      { key: "status", label: "Status" },
      { key: "type", label: "Event" },
      { key: "key", label: "Key" },
      { key: "project", label: "Project" }
    ],
    EVENTS_CSV: ["type", "status", "email", "updatedAt", "id", "url", "key", "project", "message"],
    PROJECTS: {
      BASE: [
        { key: "name", label: "Name", isHeader: true },
        { key: "acronym", label: "Acronym" },
        { key: "name", label: "Tags" },
        { key: "activeUsers", label: "Active users" },
        { key: "latestUseId", label: "Last use id" },
        { key: "online", label: "Allow access" }
      ],
      MANAGE: [
        { key: "name", label: "Name", isHeader: true },
        { key: "name", label: "Tags" },
        { key: "activeUsers", label: "Active users" },
        { key: "user.email", label: "Active user" },
        { key: "project.assigned", label: "Assigned" }
      ]
    },

    REQUESTS: {
      PENDING: [
        { key: "updatedAt", label: "Issued", isHeader: true },
        { key: "status", label: "Status" },
        { key: "requester", label: "Created by" },
        { key: "subject", label: "Subject" },
        { key: "project", label: "Project" }
      ],
      CLOSED: [
        { key: "updatedAt", label: "Issued", isHeader: true },
        { key: "status", label: "Status" },
        { key: "requester", label: "Created by" },
        { key: "approver", label: "Approved by" },
        { key: "subject", label: "Subject" },
        { key: "project", label: "Project" }
      ]
    }
  },
  ALGORITHMS: {
    GENERATE: [
      { key: "RSA2048", hidden: false, disabled: false },
      { key: "RSA3072", hidden: false, disabled: false },
      { key: "RSA4096", hidden: false, disabled: false },
      { key: "EC256", hidden: true, disabled: true },
      { key: "EC384", hidden: true, disabled: true },
      { key: "EC521", hidden: true, disabled: true },
      { key: "DH1024", hidden: true, disabled: true },
      { key: "DH2048", hidden: true, disabled: true },
      { key: "DH4096", hidden: true, disabled: true },
      { key: "MLDSA44", hidden: true, disabled: true },
      { key: "MLDSA65", hidden: true, disabled: true },
      { key: "MLDSA87", hidden: true, disabled: true },
      { key: "MLKEM512", hidden: false, disabled: false },
      { key: "MLKEM768", hidden: false, disabled: false },
      { key: "MLKEM1024", hidden: false, disabled: false }
    ],
    WRAP: [
      { key: "RSA_OEAP", hidden: false, disabled: false },
      { key: "RSA_OAEP_SHA1", hidden: false, disabled: false },
      { key: "RSA_OAEP_SHA256", hidden: false, disabled: false },
      { key: "RSA_OAEP_SHA512", hidden: false, disabled: false },
      { key: "RSA_PKCS", hidden: false, disabled: false },
      { key: "MLKEM", hidden: false, disabled: false },
      { key: "UNWRAPKEY_AES_CBC", hidden: false, disabled: true },
      { key: "UNWRAPKEY_AES_CBC_PAD", hidden: false, disabled: true }
    ],
    OUTPUT: [
      { key: "AES128", hidden: false, disabled: false },
      { key: "AES192", hidden: false, disabled: false },
      { key: "AES256", hidden: false, disabled: false },
      { key: "AES128_CMAC", hidden: false, disabled: false },
      { key: "AES256_CMAC", hidden: false, disabled: false }
    ]
  },
  STYLE: {
    WIDTH: { DRAWER: 180 },
    HEIGHT: { NAVBAR: "64px", FOOTER: "43px" },
    DIALOG: { padding: 2 },
    LAST_CHILD_NO_BORDER: { "&:last-child td, &:last-child th": { border: 0 } }
  }
};

export default conf;
